module.exports = __webpack_public_path__ + "img/puyangshiyitihuashifanquAppImage.ed92127f.png";